import React from 'react'

import { Media } from '@syconium/little-miss-figgy'

import { useLocalization } from '../../../app/_providers/LocalizationProvider.client'
import { usePersonalization } from '../../../app/_providers/PersonalizationProvider.client'
import {
  AlternateModelVariantAction,
  NavListItem as NavListItemType,
  NavListSection as Props,
} from '../../../types/graphql/site-fixtures'
import { NavListItem } from '../NavListItem'

import { Body, Divider, MarginFixer, MarginFixerList } from './styles'

// Quick hack before BFCM to hide pages we currently do not want to show for international regions
// Will be followed up with a more robust solution post BFCM
const omitFromIntl: (string | null)[] = ['/pages/gift-card-collection', '/collections/figs-eko']

export const NavListSection: React.FC<Props> = ({ variant, items }) => {
  const { isUSRegion } = useLocalization()
  const { validatePersonalizationTargetCriteria } = usePersonalization()

  return (
    <Body>
      <MarginFixer variant={variant} role='list'>
        {items.map(item => {
          if (item.__typename === 'AppNavListItem') return null

          let listItem = item
          if (item.alternateModelVariant && item.alternateModelVariant.targetCriteria) {
            if (validatePersonalizationTargetCriteria(item.alternateModelVariant.targetCriteria)) {
              if (item.alternateModelVariant.action === AlternateModelVariantAction.hideOriginal) {
                return null
              } else if (
                !!item.alternateModelVariant.validContentfulModel &&
                item.alternateModelVariant.validContentfulModel.__typename === 'NavListItem'
              ) {
                listItem = item.alternateModelVariant.validContentfulModel as NavListItemType
              }
            }
          }

          // TODO: Fix this auto-generated suppression.
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          if (!isUSRegion && omitFromIntl.includes(listItem?.href)) {
            return null
          }

          return (
            <MarginFixerList key={listItem.id} isHeading={listItem.isHeading} role='none'>
              {item.hasDivider && !item.hasDividerMobileOnly && <Divider />}
              {item.hasDividerMobileOnly && (
                <Media lessThan='md'>
                  <Divider style={{ margin: 0 }} />
                </Media>
              )}
              <NavListItem
                {...listItem}
                asTag='div'
                role='none'
                isInFooter={variant === 'footer'}
              />
            </MarginFixerList>
          )
        })}
      </MarginFixer>
    </Body>
  )
}
